// extracted by mini-css-extract-plugin
export default {"readMore":"HideExtensiveText-module__readMore__F4vjq","button":"HideExtensiveText-module__button__STtPS"};